module.exports = __webpack_public_path__ + "img/image (18).ae960ad1.jpg";